module.exports = __webpack_public_path__ + "img/insurance-icon-sidebar.d416d0e4.svg";